import React, { useState, useEffect } from 'react';
import './RegistrationSuccess.css';

export default function RegistrationSuccess({ vendorName, company, isAlreadyRegistered = false }) {
    const [showCheckmark, setShowCheckmark] = useState(false);

    useEffect(() => {
        if (isAlreadyRegistered) {
            // After 5 seconds, change blue exclamation to green checkmark
            const timer = setTimeout(() => {
                setShowCheckmark(true);
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [isAlreadyRegistered]);

    return (
        <div className="registration-success-container">
            <div className="success-card">
                <div className="success-icon" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {isAlreadyRegistered ? (
                        showCheckmark ? (
                            // Green checkmark after 5 seconds
                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transition: 'all 0.3s ease' }}>
                                <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="#d1fae5" />
                                <path d="M8 12l2 2 4-4" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        ) : (
                            // Blue exclamation mark initially
                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transition: 'all 0.3s ease' }}>
                                <circle cx="12" cy="12" r="10" stroke="#3b82f6" strokeWidth="2" fill="#dbeafe" />
                                <path d="M12 8v4M12 16h.01" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        )
                    ) : (
                        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="#d1fae5" />
                            <path d="M8 12l2 2 4-4" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </div>
                <h1 className="success-title">
                    {isAlreadyRegistered ? 'Your Response Has Been Recorded' : 'Registration is in Approval stages'}
                </h1>
                <p className="success-message">
                    {isAlreadyRegistered
                        ? 'Your registration has already been completed. Please wait for approval.'
                        : 'Your registration has been completed successfully. Your response has been recorded.'
                    }
                </p>
                {vendorName && (
                    <div className="success-info">
                        <p><strong>Vendor:</strong> {vendorName}</p>
                        {company && <p><strong>Company:</strong> {company}</p>}
                    </div>
                )}
                <div className="success-note">
                    <p>
                        {isAlreadyRegistered
                            ? 'You will be notified once your registration is reviewed. No further action is required.'
                            : 'Please wait for approval. You will be notified once your registration is reviewed.'
                        }
                    </p>
                </div>
            </div>

            <div style={{ position: 'fixed', bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0', zIndex: 1000 }}>
                <span style={{ fontWeight: '600', color: '#fff', marginRight: '10px' }}>Powered by</span>
                <img draggable={false} src="/Main.png" alt="STL-DIGITAL" style={{ height: '30px' }} />
            </div>
        </div>
    );
}

